import { render, staticRenderFns } from "./CMProfile.vue?vue&type=template&id=27a0ba9f&scoped=true&"
import script from "./CMProfile.vue?vue&type=script&lang=js&"
export * from "./CMProfile.vue?vue&type=script&lang=js&"
import style0 from "./CMProfile.vue?vue&type=style&index=0&id=27a0ba9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0ba9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a0ba9f')) {
      api.createRecord('27a0ba9f', component.options)
    } else {
      api.reload('27a0ba9f', component.options)
    }
    module.hot.accept("./CMProfile.vue?vue&type=template&id=27a0ba9f&scoped=true&", function () {
      api.rerender('27a0ba9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/CMProfile.vue"
export default component.exports